import config from "./config";
import { Client, PrintClient, SavedScenario, UserInfo } from "src/types";
// import config from "./config";

const API = config.API_URL;

export const helpUrl = `${API}help`;

const fetchApi = async (url: string, options: any) => {
  try {
    const resp = await window.fetch(url, options);
    if (!resp.ok) {
      throw resp.status;
    }
    return await resp.json();
  } catch (e) {
    console.error("aaaaaa", e);
  }
};

export const createClient = (client: Client) => {
  return fetch(API + "clients", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(client),
  });
};

export const deleteClient = (client: Client) => {
  return fetch(API + `client/${client.id}`, {
    method: "DELETE",
  });
};

export const duplicateClient = (client: Client, name: string) => {
  return fetch(API + `client/${client.id}/duplicate`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ name }),
  });
};

export const getClients = () => {
  return fetchApi(API + "clients", {
    method: "GET",

    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getTasks = () => {
  return fetchApi(API + "tasks", {
    method: "GET",

    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getAllTasks = () => {
  return fetchApi(API + "tasks/all", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};
export const getClientTasks = (id: number) => {
  return fetchApi(API + `client/${id}/tasks`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getTask = (id: string) => {
  return fetch(API + `task/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const createTask = (task: {
  description: string;
  assignee?: string;
  dueDate?: string;
  clientId: number;
}) => {
  return fetch(API + "tasks", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(task),
  });
};

export const updateTask = (
  id: string,
  task: {
    description?: string;
    assignee?: string;
    dueDate?: string;
    completed?: boolean;
  },
) => {
  return fetch(API + `task/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(task),
  });
};

export const deleteTask = (id: string) => {
  return fetch(API + `task/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getClient = (id: string) => {
  return fetch(API + `client/${id}`, {
    method: "GET",

    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getPrintClient = async (id: any): Promise<PrintClient> => {
  // See config.ts: "imapper-", not "im-", because the printer is shared with
  // Kerdora and "im-server" resolves to whichever server shares its network.
  const local =
    navigator.userAgent === "printer"
      ? "http://imapper-server:3000/"
      : "http://localhost:3000/";
  const base = import.meta.env.VITE_ENV === "local" ? local : API;
  return fetch(base + `print/client/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  }).then((res) => res.json());
};

export const updateData = (id: string, data: Client) => {
  return fetch(API + `client/${id}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
};

export const applyToAll = (name: string, value: boolean) => {
  return fetch(API + `user/featureToggle`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ name, value }),
  });
};

export const updateScenarioApi = (id: number, data: Partial<SavedScenario>) => {
  return fetch(API + `scenario/${id}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
};

export const saveScenarioApi = (data: Partial<SavedScenario>) => {
  return fetch(API + `scenario`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
};

export const deleteScenarioApi = (id: number) => {
  return fetch(API + `scenario/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getUser = () => {
  return fetch(API + "user", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const updateSettings = (settings: UserInfo) => {
  const result = settings;
  delete (result as any).email;
  return fetch(API + "settings", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(result),
  });
};

export const uploadLogo = (logo: File) => {
  const formData = new FormData();
  formData.append("logo", logo);

  return fetch(API + "user/logo", {
    method: "POST",
    body: formData,
  });
};
